/** বাংলা dictionary — must carry every key `en` defines (compile-checked). */
export const bn = {
    common: {
        open: "খুলুন",
        appName: "DrinkPure",
        skipToContent: "মূল কনটেন্টে যান",
        tagline: "সবার জন্য নিরাপদ পানি",
        loading: "লোড হচ্ছে…",
        retry: "আবার চেষ্টা করুন",
        cancel: "বাতিল",
        confirm: "নিশ্চিত করুন",
        back: "ফিরে যান",
        continue: "এগিয়ে যান",
        updatedJustNow: "এইমাত্র আপডেট",
        safeToRetry: "নিশ্চিন্তে আবার চেষ্টা করুন — দুবার হবে না।",
        change: "পরিবর্তন",
        orContinueWith: "অথবা এভাবে চালিয়ে যান",
        orSignUpWith: "অথবা এভাবে সাইন আপ করুন",
        comingSoon: "শীঘ্রই এখানে আসছে।",
    },
    nav: {
        home: "হোম",
        activity: "লেনদেন",
        recharge: "রিচার্জ",
        cards: "কার্ড",
        profile: "প্রোফাইল",
    },
    welcome: {
        valueBalanceTitle: "যেকোনো জায়গা থেকে ব্যালেন্স দেখুন",
        valueBalanceBody: "আপনার ওয়ালেট ও কার্ড সবসময় হাতের মুঠোয়",
        valueRechargeTitle: "বিকাশ, নগদ বা কার্ড দিয়ে রিচার্জ করুন",
        valueRechargeBody: "এক মিনিটেরও কম সময়ে, কোনো বাড়তি ফি ছাড়া",
        valueHonestTitle: "যতটুকু পানি পাবেন, ততটুকুরই দাম",
        valueHonestBody: "পানি না পেলে টাকাও কাটা হয় না — কখনোই না",
        createAccount: "অ্যাকাউন্ট খুলুন",
        logIn: "লগ ইন",
        // {price} / {fee} filled from config; formatMoney keeps digits Western + "Tk".
        priceLine: "পানির দাম: প্রতি লিটার {price} · কার্ড প্যাক {fee}",
    },
    auth: {
        phone: "ফোন",
        email: "ইমেইল",
        phoneNumber: "ফোন নম্বর",
        emailAddress: "ইমেইল ঠিকানা",
        password: "পাসওয়ার্ড",
        phoneHelp: "যে নম্বরটি বুথে ও SMS রসিদের জন্য ব্যবহার করবেন",
        emailHelp: "SMS রসিদের জন্য পরে ফোন নম্বর যোগ করতে পারবেন",
        phoneOrEmail: "ফোন বা ইমেইল",
        phoneOrEmailHelp: "আপনার অ্যাকাউন্টে যেটি আছে",
        show: "দেখান",
        hide: "লুকান",
        haveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
        noAccount: "ড্রিংকপিউরে নতুন?",
        termsNote: "চালিয়ে গেলে আপনি ড্রিংকপিউরের শর্তে সম্মত হচ্ছেন।",
        createTitle: "অ্যাকাউন্ট খুলুন",
        stepPhone: "ফোন",
        stepCode: "কোড",
        stepPassword: "পাসওয়ার্ড",
        sendCode: "কোড পাঠান",
        enterCodeTitle: "কোডটি লিখুন",
        codeSentSms: "আমরা SMS-এ ৬ সংখ্যার কোড পাঠিয়েছি",
        codeSentEmail: "আমরা ইমেইলে ৬ সংখ্যার কোড পাঠিয়েছি",
        verify: "যাচাই করুন",
        codeExpiresIn: "কোডের মেয়াদ শেষ হবে",
        resendIn: "আবার পাঠানো যাবে",
        resendCode: "কোড আবার পাঠান",
        devCodeNote: "ডেভ কোড (শুধু স্টেজিং):",
        setPasswordTitle: "পাসওয়ার্ড দিন",
        passwordIntro: "আপনি ফোন নম্বর বা ইমেইল এবং এই পাসওয়ার্ড দিয়ে লগ ইন করবেন। কোড শুধু সাইন-আপ ও রিসেটের জন্য দরকার।",
        ruleLength: "কমপক্ষে ১০ অক্ষর",
        ruleNotGuessable: "সহজে অনুমানযোগ্য পাসওয়ার্ড নয়",
        ruleTip: "টিপ: মনে রাখার মতো ছোট একটি বাক্যই সবচেয়ে ভালো",
        loginTitle: "লগ ইন",
        forgotPassword: "পাসওয়ার্ড ভুলে গেছেন?",
        forgotHint: "আমরা আপনাকে একটি কোড পাঠাব",
        forgotTitle: "পাসওয়ার্ড রিসেট",
        forgotIntro: "আপনার ফোন বা ইমেইল দিন, আমরা পাসওয়ার্ড রিসেটের কোড পাঠাব।",
        newPassword: "নতুন পাসওয়ার্ড",
        resetPassword: "পাসওয়ার্ড রিসেট করুন",
        resetSignsOut: "রিসেট করলে অন্য সব ডিভাইস থেকে লগ আউট হয়ে যাবে।",
        done: "সম্পন্ন",
    },
    home: {
        myWallet: "আমার ওয়ালেট",
        greeting: "স্বাগতম",
        availableBalance: "ব্যবহারযোগ্য ব্যালেন্স",
        quickRecharge: "রিচার্জ",
        quickActivate: "কার্ড চালু করুন",
        recentActivity: "সাম্প্রতিক লেনদেন",
        viewAll: "সব দেখুন",
        pendingProcessing: "{amount} রিচার্জ প্রক্রিয়াধীন",
        pendingView: "দেখুন",
        frozenTitle: "এই অ্যাকাউন্টটি ফ্রোজেন",
        frozenBody: "আপনার ব্যালেন্স নিরাপদ। ব্যবহার চালিয়ে যেতে সাপোর্টে যোগাযোগ করুন।",
        frozenChip: "ফ্রোজেন",
        heldSafely: "ব্যালেন্স — নিরাপদে রাখা",
        contactSupport: "সাপোর্টে যোগাযোগ",
        newUserTitle: "এখনও কোনো ওয়ালেট নেই",
        newUserBody: "যেকোনো বুথ থেকে ৫০ টাকায় একটি সিলড প্যাক কিনে এখানে চালু করুন — কার্ড চালু করলেই আপনার ওয়ালেট তৈরি হয়।",
        newUserCta: "আমার কার্ড চালু করুন",
        boothTitle: "বুথ কোথায়?",
        boothBody: "আপনার কাছের বাজার, স্কুল ও ক্লিনিকে ড্রিংকপিউর ডিসপেনসার খুঁজুন।",
    },
    wallet: {
        detailTitle: "ওয়ালেট",
        fundedTitle: "আপনার ব্যালেন্স কীভাবে গঠিত",
        fundedNote: "আপনার দেওয়া টাকার আগে ফ্রি ক্রেডিট খরচ হয়।",
        spendsFirst: "আগে খরচ হয়",
        linkedCard: "যুক্ত কার্ড",
        rechargeCta: "রিচার্জ",
        activityCta: "লেনদেন",
        holdBannerTitle: "একটি ডিসপেন্স চলছে",
        holdBannerBody: "একটি চলমান ডিসপেন্সের জন্য {amount} সাময়িকভাবে ধরে রাখা হয়েছে — ৩ মিনিটের মধ্যে তা আপনাআপনি ফিরে আসবে।",
        holdTotal: "মোট ব্যালেন্স",
        holdHeld: "ডিসপেন্সের জন্য ধরে রাখা",
        holdAvailable: "এখন ব্যবহারযোগ্য",
        blockedTitle: "কার্ড ব্লক করা হয়েছে, আপনার টাকা নয়।",
        blockedBody: "আপনার ওয়ালেট সক্রিয় থাকে ও রিচার্জ করা যায়। একটি রিপ্লেসমেন্ট কার্ড চালু করলে তা এই একই ব্যালেন্সের সাথে যুক্ত হয়।",
        replaceCard: "কার্ড বদলান",
        viewCard: "কার্ড দেখুন",
        cardActive: "সক্রিয়",
        cardBlocked: "কার্ড ব্লকড",
        cardLost: "কার্ড হারানো",
        cardReplaced: "কার্ড বদলানো",
        source: {
            promotion: "প্রোমোশন ক্রেডিট",
            goodwill: "শুভেচ্ছা ক্রেডিট",
            correction: "সংশোধন ক্রেডিট",
            refund: "রিফান্ড",
            reversal: "রিভার্সাল",
            paid: "আপনি দিয়েছেন",
            other: "অন্যান্য ক্রেডিট",
        },
    },
    cards: {
        listTitle: "আমার কার্ড",
        activate: "একটি কার্ড চালু করুন",
        walletPrefix: "ওয়ালেট",
        safeSuffix: "নিরাপদ",
        manage: "পরিচালনা করতে ট্যাপ করুন",
        needTitle: "কার্ড দরকার?",
        needBody: "যেকোনো বুথ থেকে {fee}-তে একটি সিল করা DrinkPure প্যাক কিনুন। ভেতরে কার্ড, তার নম্বর ও একবার ব্যবহারযোগ্য চালুর কোড পাবেন।",
        activateTitle: "কার্ড চালু করুন",
        sealed: "সিল করা",
        readyToActivate: "চালুর জন্য প্রস্তুত",
        activateIntro: "আপনার সিল করা প্যাকের ভেতরে ছাপানো নম্বর ও কোড লিখুন।",
        cardNumberLabel: "কার্ড নম্বর",
        cardNumberHelp: "I ও O অক্ষর এবং 0 ও 1 সংখ্যা কখনো ব্যবহার হয় না — দেখতে যেটার মতো, সেটা আসলে অন্যটি।",
        cardNumberPlaceholder: "DP__ ____ ____ __",
        codeLabel: "চালুর কোড",
        codePlaceholder: "১০টি অক্ষর",
        replaceToggle: "এটি একটি হারানো বা ব্লক করা কার্ডের বদলি",
        replaceHint: "পুরনো কার্ডটি বেছে নিন — তার ওয়ালেট ও ব্যালেন্স নতুন কার্ডে চলে যাবে:",
        replaceCarry: "ব্যালেন্স {amount} — চলে যাবে",
        activateAction: "চালু করুন",
        mode2Title: "বুথে হাতের কাছে ফোন নেই?",
        mode2Body: "যেকোনো ডিসপেন্সারেও নতুন কার্ড চালু করা যায়: সিল করা কার্ডটি ট্যাপ করুন, মেশিনে আপনার নম্বর দিন, SMS কোড নিশ্চিত করুন — হয়ে গেল। (রিপ্লেসমেন্ট শুধু অ্যাপে।)",
        errAmbiguous: "“{char}” আছে — 0, 1, I ও O কখনো ব্যবহার হয় না।",
        errCardPrefix: "কার্ড নম্বর DP দিয়ে শুরু হয়।",
        errCardIncomplete: "এটি এখনও পূর্ণ কার্ড নম্বর নয়।",
        errCodeIncomplete: "এটি এখনও পূর্ণ চালুর কোড নয়।",
        successNewTitle: "{token} চালু হয়েছে",
        successNewBody: "এই কার্ডের জন্য একটি নতুন ওয়ালেট তৈরি হয়েছে। আপনি SMS নিশ্চিতকরণ পাবেন।",
        walletBalance: "ওয়ালেট ব্যালেন্স",
        cardLabel: "কার্ড",
        rechargeNow: "এখনই রিচার্জ করুন",
        later: "পরে",
        successReplaceTitle: "বদলি সম্পন্ন",
        successReplaceBody: "আপনার পুরনো কার্ড ({oldToken}) অবসর নিয়েছে। আপনার {amount} নতুন কার্ডে চলে গেছে — একই ওয়ালেট, নতুন চাবি।",
        newCard: "নতুন কার্ড",
        balanceCarried: "স্থানান্তরিত ব্যালেন্স",
        oldCard: "পুরনো কার্ড",
        replaced: "বদলানো",
        done: "সম্পন্ন",
        alreadyActiveTitle: "এই কার্ডটি ইতিমধ্যে সক্রিয়।",
        alreadyActiveBody: "এটি আপনার হলে, আপনার কার্ড তালিকায় পাবেন। সিল করা কিনে থাকলে এবং এমন দেখালে ব্যবহার করবেন না — বুথে ফেরত দিন এবং {support}-এ কল করুন।",
        backToMyCards: "আমার কার্ডে ফিরুন",
        conflictTitle: "এই কার্ডটি ভিন্ন তথ্যে ইতিমধ্যে ব্যবহৃত হয়েছে।",
        conflictBody: "আপনার নিরাপত্তার জন্য এটি এখানে আবার ব্যবহার করা যাবে না। অনুগ্রহ করে {support}-এ সাপোর্টে যোগাযোগ করুন।",
        inProgress: "এই চালুর কাজটি এখনও প্রক্রিয়াধীন — একটু পরে আবার চেষ্টা করুন।",
        detailTitle: "কার্ড",
        historyTitle: "ইতিহাস",
        tlActiveNow: "সক্রিয় — ট্যাপ আপনার ওয়ালেট থেকে খরচ করে",
        tlSince: "{date} থেকে",
        tlBlockedNow: "ব্লক করা হয়েছে",
        tlLostNow: "হারানো রিপোর্ট করা হয়েছে",
        tlActivated: "অ্যাপে চালু করা হয়েছে",
        lostQTitle: "কার্ড হারিয়েছেন?",
        lostQBody: "লক্ষ্য করামাত্র ব্লক করুন — ট্যাপ সঙ্গে সঙ্গে বন্ধ হয় এবং আপনার ব্যালেন্স ওয়ালেটে নিরাপদ থাকে।",
        blockAction: "কার্ড ব্লক করুন",
        reportLostAction: "হারানো রিপোর্ট",
        blockConfirmTitle: "এই কার্ডটি ব্লক করবেন?",
        blockConfirmBody: "বুথে ট্যাপ সঙ্গে সঙ্গে বন্ধ হবে। আপনার {amount} ওয়ালেটে নিরাপদ থাকবে।",
        blockConfirmNote: "পরে আবার চালু করতে DrinkPure সাপোর্ট লাগবে — অ্যাপ থেকে আনব্লক করা যায় না।",
        lostConfirmTitle: "এই কার্ডটি হারানো রিপোর্ট করবেন?",
        lostConfirmBody: "এটি স্থায়ী — হারানো কার্ড আবার চালু করা যায় না। ট্যাপ সঙ্গে সঙ্গে বন্ধ হয় এবং আপনার {amount} নিরাপদ থাকে। একটি রিপ্লেসমেন্ট চালু করে যেকোনো সময় ব্যালেন্স নতুন কার্ডে নিতে পারেন।",
        blockedTitle: "আনব্লক করতে সত্যিই একজন মানুষ লাগে।",
        blockedBody: "নিরাপত্তার জন্য ব্লক করা কার্ড কেবল DrinkPure সাপোর্ট আবার চালু করতে পারে — অ্যাপ থেকে নয়। {support}-এ কল করুন বা আপনার ফোন নম্বর নিয়ে যেকোনো বুথে যান।",
        lostSafeTitle: "ট্যাপ বন্ধ এবং আপনার {amount} নিরাপদ।",
        lostSafeBody: "যেকোনো বুথ থেকে {fee}-তে একটি নতুন সিল করা প্যাক কিনে রিপ্লেসমেন্ট হিসেবে চালু করুন — ব্যালেন্স নতুন কার্ডে চলে যায়।",
        activateReplacement: "রিপ্লেসমেন্ট কার্ড চালু করুন",
    },
    activity: {
        title: "লেনদেন",
        emptyTitle: "এখনও কোনো লেনদেন নেই",
        emptyBody: "আপনার পানি কেনা ও রিচার্জ এখানে দেখা যাবে।",
        loadMore: "আরও দেখুন",
        footnote: "প্রমাণিত ডেলিভারি ছাড়া কখনো টাকা কাটা হয় না।",
        balanceAfter: "পরবর্তী ব্যালেন্স",
        partial: "আংশিক",
        completed: "সম্পন্ন",
        today: "আজ",
        yesterday: "গতকাল",
        category: {
            waterPurchase: "পানি কেনা",
            recharge: "রিচার্জ",
            supportCredit: "সাপোর্ট ক্রেডিট",
            reversal: "রিভার্সাল",
        },
        askedFor: "আপনি চেয়েছেন {vol}",
        received: "আপনি পেয়েছেন {vol}",
        machineStopped: "মেশিনটি আগেই থেমে গেছে। যতটুকু পানি আসলে বেরিয়েছে, শুধু ততটুকুরই টাকা কাটা হয়েছে।",
        fullyDelivered: "আপনি যতটুকু চেয়েছিলেন পুরোটাই দেওয়া হয়েছে।",
        charged: "কাটা হয়েছে",
        holdReleased: "হোল্ড ছেড়ে দেওয়া",
        holdReleasedNote: "“হোল্ড ছেড়ে দেওয়া” মানে পুরো {vol}-এর জন্য {amount} ধরে রাখা হয়েছিল কিন্তু আপনার ওয়ালেট থেকে কখনো নেওয়া হয়নি — এটি রিফান্ড নয়, কারণ টাকা কখনো বেরই হয়নি।",
        receiptRef: "রসিদ রেফ",
        receiptRefGap: "এখনও পাওয়া যায়নি",
        reversalExplain: "ভুলে কাটা একটি ডেবিট সংশোধন করা হয়েছে। মূল এন্ট্রি আপনার ইতিহাসে থেকে যায় — সংশোধন সবসময় নতুন এন্ট্রি, কখনো সম্পাদনা নয়।",
        reason: "কারণ",
        reversalSpend: "আপনার দেওয়া টাকার আগে এই ক্রেডিট খরচ হয়।",
        close: "বন্ধ করুন",
    },
    profile: {
        title: "প্রোফাইল",
        yourAccount: "আপনার অ্যাকাউন্ট",
        verified: "যাচাইকৃত",
        rechargeHistory: "রিচার্জ ইতিহাস",
        rechargeHistorySub: "আপনার আগের টপ-আপ ও সেগুলোর অবস্থা",
        changePhone: "ফোন নম্বর পরিবর্তন",
        changePhoneSub: "নতুন নম্বরে কোড পাঠিয়ে যাচাই হবে",
        changePassword: "পাসওয়ার্ড পরিবর্তন",
        changePasswordSub: "কোড দিয়ে রিসেট — অন্য ডিভাইস লগ আউট হয়ে যাবে",
        language: "ভাষা",
        languageSub: "সাথে সাথেই বদলে যায়",
        help: "সহায়তা ও দাম",
        helpSub: "চার্জ কীভাবে হয়, রিফান্ড, বুথ গাইড",
        logOut: "লগ আউট",
    },
    help: {
        title: "সহায়তা ও দাম",
        pricesTitle: "পানির দাম",
        perLitre: "প্রতি লিটার",
        packagesLabel: "1 L · 2 L · 5 L · 10 L",
        newCardPack: "নতুন কার্ড প্যাক",
        pricesNote: "দাম সব বুথে একই, ভ্যাটসহ। বোতাম শুধু সুবিধার জন্য — চার্জ সবসময় লিটার × দাম।",
        howTitle: "চার্জ কীভাবে হয়",
        howFull: "পুরো পানি পেলে পুরো দাম",
        howPartial: "মেশিন মাঝপথে থামলে — যতটুকু পেয়েছেন, ঠিক ততটুকুরই দাম",
        howNone: "পানি একেবারেই না এলে — ৳০, কোনো চার্জ নেই, স্টেটমেন্টে কোনো লাইনও থাকবে না",
        refundTitle: "নগদ টাকায় কিনলে ফেরত",
        refundBody: "নগদে কিনে পানি কম পেলে মেশিনের পর্দায় ফেরতের টাকা দেখায় — সেটি বুথকর্মীর কাছ থেকে তখনই নিয়ে নিন। পরে সমস্যা হলে হটলাইনে কল করুন।",
        smsTitle: "কখন SMS পাবেন",
        smsBody: "রিচার্জ সফল হলে, ব্যালেন্সে ক্রেডিট বা সংশোধন এলে, কার্ড চালু/ব্লক/হারানো হলে এবং নম্বর বদলালে। প্রতিটি পানি কেনায় SMS যায় না — সব লেনদেন এই অ্যাপের Activity-তে।",
        supportTitle: "সহায়তা",
        supportHours: "প্রতিদিন সকাল ৮টা – রাত ১০টা",
        supportRef: "সমস্যার কথা বলার সময় লেনদেনের রেফারেন্স (যেমন DP-TR-9K3FQ2) বললে দ্রুত সমাধান হবে।",
    },
    crash: {
        title: "এই স্ক্রিনে একটি সমস্যা হয়েছে",
        body: "দুঃখিত — একটি অপ্রত্যাশিত ত্রুটির কারণে পেজটি থেমে গেছে। আপনার ব্যালেন্স ও টাকা নিরাপদ। চালিয়ে যেতে রিলোড করুন; বারবার হলে {support}-এ কল করুন।",
        reload: "রিলোড",
    },
    recharge: {
        title: "ওয়ালেট রিচার্জ",
        whichWallet: "কোন ওয়ালেটে?",
        howMuch: "কত টাকা?",
        amountHelp: "সর্বনিম্ন {min} · সর্বোচ্চ {max} · {amount} ≈ {litres} লিটার পানি",
        payWith: "পেমেন্ট মাধ্যম",
        providerName: "মোবাইল ব্যাংকিং / কার্ড",
        providerHint: "নিরাপদ পেমেন্ট পেজে গিয়ে আপনি সঠিক মাধ্যম বেছে নেবেন",
        payButton: "{amount} পরিশোধ করুন",
        feeNote: "কোনো বাড়তি ফি নেই — গেটওয়ে চার্জ ড্রিংকপিউর বহন করে। পেমেন্ট নিশ্চিত হওয়ার পরেই আপনার ওয়ালেটে যোগ হয়।",
        belowMin: "সর্বনিম্ন রিচার্জ {min}",
        aboveMax: "সর্বোচ্চ রিচার্জ {max}",
        inflightTitle: "আপনার আগের চেষ্টাটি এখনও প্রক্রিয়াধীন।",
        inflightBody: "এখনই আবার চেষ্টা করবেন না — দুবার টাকা কাটা হবে না; আমরা ফলাফল আনছি।",
        inflightView: "স্ট্যাটাস দেখুন",
        gatewayDownTitle: "পেমেন্ট সেবা এই মুহূর্তে সাড়া দিচ্ছে না।",
        gatewayDownBody: "কোনো টাকা কাটা হয়নি। কয়েক মিনিট পর আবার চেষ্টা করুন।",
        walletBlockedCardNote: "কার্ড ব্লকড, ওয়ালেট সক্রিয়",
        processingTitle: "আপনার পেমেন্ট নিশ্চিত করা হচ্ছে…",
        processingBody: "সাধারণত কয়েক সেকেন্ড লাগে। ব্যাংকের সাথে পেমেন্ট যাচাই হলেই আপনার ওয়ালেটে যোগ হয় — তার আগে নয়।",
        processingAttempt: "আবার আপনাআপনি দেখা হচ্ছে… (চেষ্টা {n})",
        successTitle: "{amount} যোগ হয়েছে",
        successPaidWith: "{method} দিয়ে পরিশোধ · একটি SMS রসিদ পাঠানো হচ্ছে।",
        successPaid: "পরিশোধিত",
        newBalance: "নতুন ব্যালেন্স",
        notCreditedTitle: "পেমেন্ট গৃহীত — ব্যালেন্স আপডেট হচ্ছে",
        notCreditedBody: "গেটওয়ে আপনার পেমেন্ট নিশ্চিত করেছে। আমরা এখন তা আপনার ওয়ালেটে লিখছি; একটু পরেই ব্যালেন্স আপডেট হবে।",
        checkAgain: "আবার দেখুন",
        failedTitle: "পেমেন্ট সম্পন্ন হয়নি",
        failedBody: "পেমেন্ট প্রোভাইডার প্রত্যাখ্যান করেছে। আপনার অ্যাকাউন্ট থেকে কোনো টাকা যায়নি — কিছু কাটা হলে প্রোভাইডার তা আপনাআপনি ফেরত দেয়।",
        attempted: "চেষ্টা করা হয়েছিল",
        cancelledTitle: "রিচার্জ বাতিল",
        cancelledBody: "আপনি পেমেন্ট পেজে বাতিল করেছেন। কোনো টাকা কাটা হয়নি।",
        expiredTitle: "এই চেষ্টার মেয়াদ শেষ",
        expiredBody: "পেমেন্ট উইন্ডো (৩০ মিনিট) নিশ্চিত পেমেন্ট ছাড়াই পার হয়েছে। কোনো টাকা কাটা হয়নি। আপনি পরিশোধ করে থাকলে ও এক ঘণ্টার মধ্যে না দেখালে নিচের রেফারেন্স নিয়ে সাপোর্টে যোগাযোগ করুন।",
        stuckTitle: "এখনও নিশ্চিত হচ্ছে…",
        stuckBody: "ব্যাংক স্বাভাবিকের চেয়ে বেশি সময় নিচ্ছে। আপনাকে কিছু করতে হবে না — পেমেন্ট হয়ে থাকলে আপনার ওয়ালেটে আপনাআপনি যোগ হবে ও আপনি SMS পাবেন। না হলে কোনো টাকা কাটা হয়নি।",
        stuckCheckHistory: "পরে রিচার্জ ইতিহাসে দেখুন",
        loggedOutTitle: "গেটওয়ে পেমেন্ট গ্রহণ করেছে",
        loggedOutBody: "পেমেন্টের সময় আপনার সেশন শেষ হয়েছে। রিচার্জ যোগ হয়েছে কিনা দেখতে লগ ইন করুন — ফলাফল যেকোনোভাবেই নিরাপদ।",
        loggedOutLogin: "ফলাফল দেখতে লগ ইন করুন",
        missingTitle: "রিচার্জ পাওয়া যায়নি",
        missingBody: "সেই রিচার্জটি খুঁজে পাওয়া যায়নি। আপনার রিচার্জ ইতিহাস দেখুন।",
        amount: "পরিমাণ",
        wallet: "ওয়ালেট",
        reference: "রেফারেন্স",
        done: "সম্পন্ন",
        viewActivity: "লেনদেন দেখুন",
        tryAgain: "আবার চেষ্টা করুন",
        startAgain: "আবার শুরু করুন",
        startNew: "নতুন রিচার্জ শুরু করুন",
        backHome: "হোমে ফিরুন",
        copyRef: "রেফারেন্স কপি করুন",
        copied: "কপি হয়েছে",
        historyTitle: "রিচার্জ ইতিহাস",
        statusPending: "প্রক্রিয়াধীন",
        statusSuccess: "সফল",
        statusFailed: "ব্যর্থ",
        statusCancelled: "বাতিল",
        statusExpired: "মেয়াদোত্তীর্ণ",
        failedMoneyNotTaken: "প্রোভাইডার প্রত্যাখ্যান · টাকা কাটা হয়নি",
        cancelledSub: "আপনি পেমেন্ট পেজে বাতিল করেছেন",
        historyFootnote: "প্রক্রিয়াধীন রিচার্জ আপনাআপনি সম্পন্ন হয় — লাইভ স্ট্যাটাস দেখতে যেকোনো সময় ট্যাপ করুন।",
        emptyTitle: "এখনও কোনো রিচার্জ নেই",
        emptyBody: "বিকাশ, নগদ, রকেট বা কার্ড দিয়ে টপ আপ করুন — কয়েক সেকেন্ডেই ব্যালেন্স যোগ হয়।",
        rechargeNow: "এখনই রিচার্জ করুন",
    },
    errors: {
        network: "ড্রিংকপিউরের সাথে সংযোগ হচ্ছে না — ইন্টারনেট দেখে আবার চেষ্টা করুন।",
        invalid_credentials: "ফোন নম্বর, ইমেইল বা পাসওয়ার্ড মেলেনি।",
        registration_conflict: "এই নম্বর/ইমেইলে ইতিমধ্যে অ্যাকাউন্ট আছে। বরং লগ ইন করুন।",
        channel_unavailable: "ইমেইল সাইন-ইন এখনও চালু হয়নি — অনুগ্রহ করে ফোন নম্বর ব্যবহার করুন।",
        invalid_otp: "কোডটি কাজ করেনি। সর্বশেষ মেসেজ দেখুন — কোড পাঠানোর ৫ মিনিট পর মেয়াদ শেষ হয়।",
        otp_expired: "কোডের মেয়াদ শেষ। চালিয়ে যেতে একটি নতুন কোড নিন।",
        weak_password: "এই পাসওয়ার্ড সহজেই অনুমান করা যায় — একটি লম্বা, ব্যক্তিগত বাক্য দিন।",
        completion_expired: "এই ধাপটির সময় শেষ। আবার আপনার কন্টাক্ট যাচাই করুন — কয়েক সেকেন্ড লাগবে।",
        rate_limited: "অনেকবার চেষ্টা হয়েছে — একটু পরে আবার চেষ্টা করুন।",
        account_locked: "অনেকবার চেষ্টা হয়েছে। নিরাপত্তার জন্য কয়েক মিনিট পর আবার চেষ্টা করুন।",
        // ---- ম্যানেজ/কনসোল অথ ----
        totp_invalid: "কোডটি মেলেনি। আপনার অথেন্টিকেটর অ্যাপের বর্তমান ৬-সংখ্যার কোডটি দিন।",
        unauthenticated: "আপনার সেশন শেষ হয়েছে। আবার সাইন ইন করুন।",
        inactive: "এই অ্যাকাউন্টটি সক্রিয় নয়। একজন অ্যাডমিনকে এটি আবার সক্রিয় করতে বলুন।",
        no_credential: "এই অ্যাকাউন্টের জন্য এখনও কোনো পাসওয়ার্ড সেট করা নেই। ops CLI দিয়ে একটি সেট করতে অ্যাডমিনকে বলুন।",
        unauthorized: "আপনার সেশন শেষ হয়েছে। আবার লগ ইন করুন।",
        forbidden: "এখানে আপনার প্রবেশাধিকার নেই।",
        not_found: "এটি খুঁজে পাওয়া যায়নি।",
        conflict: "এটি প্রয়োগ হয়নি — অন্য কোথাও বদলে থাকতে পারে। রিফ্রেশ করে আবার চেষ্টা করুন।",
        amount_below_minimum: "এই পরিমাণ সর্বনিম্ন রিচার্জের কম।",
        amount_above_maximum: "এই পরিমাণ সর্বোচ্চ রিচার্জের বেশি।",
        wallet_not_active: "এই ওয়ালেটটি এখন রিচার্জ করা যাচ্ছে না।",
        payment_provider_unavailable: "পেমেন্ট সেবা এই মুহূর্তে সাড়া দিচ্ছে না। কোনো টাকা কাটা হয়নি — একটু পরে আবার চেষ্টা করুন।",
        in_progress: "আপনার আগের চেষ্টাটি এখনও প্রক্রিয়াধীন — আবার চেষ্টার দরকার নেই।",
        activation_code_invalid: "কোডটি এই কার্ডের সাথে মেলে না। প্যাকের ভেতরে ছাপানো কোডটি আবার দেখুন।",
        card_not_found: "এই নম্বরের কোনো কার্ড পাওয়া যায়নি। প্যাকের ভেতরে ছাপানো নম্বরটি দেখুন।",
        card_state_conflict: "প্রয়োগ হয়নি — এই কার্ডের অবস্থা বদলে গেছে। রিফ্রেশ করে আবার চেষ্টা করুন।",
        activation_conflict: "এই কার্ডটি ভিন্ন তথ্যে ইতিমধ্যে ব্যবহৃত হয়েছে। অনুগ্রহ করে সাপোর্টে যোগাযোগ করুন।",
        activation_in_progress: "এই চালুর কাজটি এখনও প্রক্রিয়াধীন — একটু পরে আবার চেষ্টা করুন।",
        replaces_card_not_found: "যে কার্ডটি বদলাচ্ছেন সেটি পাওয়া যায়নি। কার্ড রিফ্রেশ করে আবার চেষ্টা করুন।",
        card_not_owned: "এই কার্ডটি আপনার অ্যাকাউন্টে নেই।",
        customer_not_active: "আপনার অ্যাকাউন্ট এই মুহূর্তে সক্রিয় নয়। চালিয়ে যেতে সাপোর্টে যোগাযোগ করুন।",
        // ---- firmware ----
        reason_required: "একটি কারণ দরকার।",
        device_not_found: "বুথটি খুঁজে পাওয়া যায়নি।",
        release_not_found: "রিলিজটি খুঁজে পাওয়া যায়নি।",
        rollout_not_found: "রোলআউটটি খুঁজে পাওয়া যায়নি।",
        rollout_open: "আরেকটি রোলআউট চালু আছে। আগে সেটি শেষ বা বাতিল করুন।",
        rollout_closed: "এই রোলআউট শেষ হয়ে গেছে; এতে আর কিছু করা যাবে না।",
        rollout_not_active: "এই রোলআউট থামানো আছে। আগে আবার চালু করুন।",
        stage_not_done: "বর্তমান ধাপে কোনো বুথ এখনও চলমান, অথবা সোক টাইম পূর্ণ হয়নি।",
        last_stage: "এই রোলআউট ইতিমধ্যে শেষ ধাপে আছে।",
        release_unavailable: "এই রিলিজ আর রোলআউট করা যাবে না: এটি ডিপ্রিকেটেড বা রিভোকড।",
        release_revoked: "এই রিলিজ রিভোক করা হয়েছে।",
        no_firmware_report: "এই বুথ এখনও তার ফার্মওয়্যার জানায়নি।",
        not_revertible: "এই বুথ এখন ফিরে যাওয়ার মতো কোনো ইমেজ জানায়নি।",
        revert_pending: "এই বুথ ফিরিয়ে পাঠানোর একটি অনুরোধ ইতিমধ্যে চলছে।",
        unknown: "আমাদের দিকে একটি সমস্যা হয়েছে। কোনো টাকা কাটা হয়নি।",
    },
    // ---- অপারেটর কনসোল ----
    manage: {
        brand: "DrinkPure",
        consoleTag: "অপারেটর কনসোল",
        logout: "লগ আউট",
        refresh: "রিফ্রেশ",
        environment: "এনভায়রনমেন্ট",
        yourRole: "আপনার ভূমিকা",
        refreshNow: "এখনই ডেটা রিফ্রেশ করুন",
        freshnessIdle: "লাইভ",
        boot: "অপারেটর কনসোল",
        roles: {
            admin: "অ্যাডমিন",
            manager: "ম্যানেজার",
            technician: "টেকনিশিয়ান",
            staff: "স্টাফ",
        },
        login: {
            title: "অপারেটর সাইন-ইন",
            subtitle: "DrinkPure অপারেশনস কনসোল",
            identifierLabel: "ইমেইল বা ফোন",
            identifierHelp: "অ্যাডমিনরা ইমেইল দিয়ে · স্টাফরা তাদের ফোন নম্বর দিয়ে সাইন ইন করেন",
            passwordLabel: "পাসওয়ার্ড",
            submit: "এগিয়ে যান",
            cliNote: "আপাতত পাসওয়ার্ড ops CLI দিয়ে সেট করা হয় — এখনও কোনো সেলফ-সার্ভিস রিসেট নেই।",
            sessionNote: "সেশন ১৫ মিনিট স্থায়ী হয় এবং ১২ ঘণ্টা পর্যন্ত রিফ্রেশ হয়। অ্যাকাউন্ট নিষ্ক্রিয় করা হলে সঙ্গে সঙ্গে অ্যাক্সেস বাতিল হয়।",
        },
        totp: {
            verifyTitle: "টু-ফ্যাক্টর কোড",
            signedInAs: "{name} হিসেবে সাইন ইন",
            codeLabel: "আপনার অথেন্টিকেটর অ্যাপের ৬-সংখ্যার কোড",
            validity: "চ্যালেঞ্জটি ৫ মিনিট পর্যন্ত বৈধ",
            verify: "যাচাই করে সাইন ইন করুন",
            differentAccount: "← অন্য অ্যাকাউন্ট",
            lostAuthenticator: "অথেন্টিকেটর হারিয়েছেন? একজন অ্যাডমিন আপনার 2FA রিসেট করতে পারেন — পরের লগইনে আবার এনরোল করবেন।",
            enrollTitle: "টু-ফ্যাক্টর সেট আপ করুন",
            enrollSubtitle: "{name}-এর প্রথম সাইন-ইন — এগিয়ে যাওয়ার আগে 2FA আবশ্যক।",
            step1: "Google Authenticator বা যেকোনো TOTP অ্যাপ ইনস্টল করুন",
            step2: "এই QR স্ক্যান করুন (বা নিচের কী টাইপ করুন)",
            step3: "নিশ্চিত করতে অ্যাপে দেখানো ৬-সংখ্যার কোড দিন",
            manualKey: "ম্যানুয়াল কী",
            codeFromApp: "অ্যাপ থেকে কোড",
            confirmFinish: "নিশ্চিত করে শেষ করুন",
            keepApp: "অ্যাপটি ফোনে রাখুন — প্রতিবার লগইনে নতুন কোড লাগবে।",
            skewTitle: "পরপর তৃতীয় কোডটিও মেলেনি।",
            skewBody: "এটি সাধারণত ফোনের ঘড়ির সমস্যা, টাইপো নয়। আপনার অথেন্টিকেটর অ্যাপে টাইম সিঙ্ক চালু করুন (যেমন Google Authenticator → Settings → Time correction), তারপর নতুন কোডটি চেষ্টা করুন।",
        },
        scope: {
            locationCount: "{count}টি লোকেশন",
            locationCountOne: "1টি লোকেশন",
            fixedLabel: "নির্ধারিত পরিধি",
            label: "স্কোপ",
            allLocations: "সব লোকেশন",
            allMyLocations: "আমার সব লোকেশন",
            fleetWide: "ফ্লিট-ওয়াইড — টাকা কখনও লোকেশন-ভিত্তিক নয়",
        },
        navGroup: {
            operations: "অপারেশনস",
            fleet: "ফ্লিট",
            network: "নেটওয়ার্ক",
            money: "টাকা",
            catalogPeople: "ক্যাটালগ ও লোকজন",
            insight: "ইনসাইট",
        },
        freshness: {
            cadence: "অটো {seconds}s",
            announceStale: "এই স্ক্রিনের ডেটা পুরনো হয়ে গেছে।",
            announceOffline: "ব্যাকএন্ডে পৌঁছানো যাচ্ছে না। সর্বশেষ পাওয়া ডেটা দেখানো হচ্ছে।",
            announceFresh: "ডেটা হালনাগাদ হয়েছে।",
            announceReconnected: "সংযোগ ফিরে এসেছে। ডেটা হালনাগাদ হয়েছে।",
            checking: "দেখা হচ্ছে…",
            updatedAgo: "{seconds} সেকেন্ড আগে আপডেট",
            offline: "ব্যাকএন্ডে পৌঁছানো যাচ্ছে না — সর্বশেষ পাওয়া তথ্য দেখানো হচ্ছে। স্বয়ংক্রিয়ভাবে আবার চেষ্টা চলছে।",
        },
        fleet: {
            showingRows: "{shown}টি দেখানো হচ্ছে",
            loadMore: "আরও দেখুন",
            endOfLog: "লগের শেষ",
            pagingCap: "{max}টিতে সীমিত — আরও পুরনো দেখতে স্ট্যাটাস বা লোকেশন দিয়ে সংকুচিত করুন",
            olderCommands: "আরও {count}টি পুরনো কমান্ড",
            pageTitle: "ফ্লিট হেলথ",
            pageSub: "“অনলাইন” মানে বুথটি গত 60 সেকেন্ডের মধ্যে ব্যাকএন্ডে একটি অনুরোধ সম্পন্ন করেছে — তাই এই পাতার ডেটা কতটা তাজা, সেটিও পড়ার অংশ।",
            loading: "ডিভাইস লোড হচ্ছে",
            loadingCommands: "কমান্ড লোড হচ্ছে",
            refreshFailed: "সর্বশেষ রিফ্রেশ ব্যর্থ হয়েছে। এগুলো তার আগে পাওয়া তথ্য।",
            colAttention: "নজর প্রয়োজন",
            colActions: "অ্যাকশন",
            noLocation: "লোকেশন নেই",
            lastSeenAgo: "সর্বশেষ দেখা {duration} আগে",
            lastSeenNever: "কখনও দেখা যায়নি",
            faultCount: "{count}টি ফল্ট",
            configPending: "কনফিগ বাকি",
            filter: {
                label: "দেখান",
                help: "স্ক্রিনে থাকা সারিগুলোই ফিল্টার করে — কনসোল যে বুথ লোড করেনি, সেটি এতে লুকায় না।",
                all: "সব বুথ",
                attention: "নজর প্রয়োজন",
                offline: "অফলাইন",
                unsynced: "অসিঙ্ক বিক্রি ধরে আছে",
                locked: "লক করা",
            },
            showingCount: "{total}টির মধ্যে {shown}টি দেখানো হচ্ছে",
            emptyFilteredTitle: "এই ফিল্টারে কিছু নেই",
            emptyFilteredBody: "এই পরিধির প্রতিটি বুথ এই মাপে স্বাভাবিক।",
            tableCaption: "ডিভাইস ও তাদের হেলথ",
            summary: {
                online: "অনলাইন",
                onlineSub: "{total}টির মধ্যে",
                offline: "অফলাইন",
                offlineSub: "60 সেকেন্ডে কোনো ব্যাকএন্ড অনুরোধ নেই",
                attention: "নজর প্রয়োজন",
                attentionSub: "ফল্ট, হোল্ড বা ড্রিফট",
                unsynced: "অসিঙ্ক জার্নাল",
                unsyncedSub: "{devices}টি বুথে আটকে থাকা রেকর্ড",
            },
            tabsLabel: "ডিভাইস ভিউ",
            tabHealth: "হেলথ",
            tabCommands: "কমান্ড",
            sectionResources: "ফার্মওয়্যার ও রিসোর্স",
            sectionCommandsDesc: "প্রতিটি কমান্ডে কে, কেন এবং ফল কী হলো — সবই রেকর্ড থাকে।",
            sectionIssueDesc: "কমান্ড বুথে কার্যকর হয় এবং আপনার নামে অডিটে ওঠে।",
            commandConsequence: {
                lock: "আনলক না করা পর্যন্ত বুথটি বিক্রি বন্ধ রাখবে।",
                unlock: "অন্য কোনো হোল্ড না থাকলে বুথটি আবার বিক্রি করতে পারবে।",
                enter_maintenance: "বুথটি গ্রাহকদের সেবা দেওয়া বন্ধ করে মেইনটেন্যান্স স্ক্রিন দেখাবে।",
                exit_maintenance: "বুথটি মেইনটেন্যান্স থেকে বেরিয়ে স্বাভাবিক সেবায় ফিরবে।",
                config_reload: "বুথটি দাম ও কনফিগারেশন আবার নেবে। সেবা বন্ধ হবে না।",
                display_message: "নিচের বার্তাটি বুথের পর্দায় দেখা যাবে।",
                restart_app: "কন্ট্রোলার রিস্টার্ট নেবে। ফিরে না আসা পর্যন্ত বুথটি অচল থাকবে।",
            },
            confirmTargetLabel: "বুথ",
            confirmDisruptive: "এই বুথে থাকা যে কেউ টের পাবেন: ফেরানো না হওয়া পর্যন্ত সেবা বন্ধ থাকবে।",
            confirmAudit: "উপরের কারণসহ আপনার অ্যাকাউন্টের নামে রেকর্ড হবে।",
            offlineIssueHelp: "এই বুথ এখন অফলাইন। কমান্ডটি সারিতে থাকবে, এবং সময়সীমার মধ্যে ডিভাইসে না পৌঁছালে “পৌঁছায়নি” হিসেবে চিহ্নিত হবে।",
            stillNeeded: "এখনও দরকার: {fields}",
            noCommandsHelp: "কনসোল বা ops CLI থেকে দেওয়া কমান্ড ফলাফলসহ এখানে দেখা যাবে।",
            commandsSub: "বুথে দেওয়া প্রতিটি কমান্ড, পৌঁছানো ও ফলাফলসহ।",
            commandsSubInFlight: "{count}টি এখনও চলমান — প্রতি 10 সেকেন্ডে দেখা হচ্ছে।",
            online: "অনলাইন",
            offline: "অফলাইন",
            onlineHelp: "ডিভাইসটি গত ৬০ সেকেন্ডে ব্যাকএন্ডে একটি রিকোয়েস্ট সম্পন্ন করেছে।",
            telemetryFresh: "টেলিমেট্রি সচল",
            telemetryStale: "টেলিমেট্রি পুরনো",
            telemetryHelp: "গত ৬০ সেকেন্ডে MQTT টেলিমেট্রি এসেছে কিনা। এটি অনলাইন থেকে আলাদা — টেলিমেট্রি পুরনো হলেও ডিভাইস স্বাভাবিকভাবে লেনদেন করতে পারে।",
            safeMode: "নিরাপদ মোড",
            deviceStatus: {
                registered: "নিবন্ধিত",
                provisioned: "প্রভিশনড",
                active: "সক্রিয়",
                inactive: "নিষ্ক্রিয়",
                locked: "লকড",
                maintenance: "মেইনটেন্যান্স",
                retired: "অবসরপ্রাপ্ত",
            },
            commandStatus: {
                pending: "অপেক্ষমাণ",
                delivered: "পৌঁছেছে",
                accepted: "গৃহীত",
                running: "চলছে",
                succeeded: "সফল",
                failed: "ব্যর্থ",
                partial: "আংশিক",
                rejected: "প্রত্যাখ্যাত",
                delivery_failed: "পৌঁছায়নি",
                execution_timeout: "ফলাফল জানায়নি",
            },
            commandType: {
                lock: "লক",
                unlock: "আনলক",
                enter_maintenance: "মেইনটেন্যান্সে নিন",
                exit_maintenance: "মেইনটেন্যান্স থেকে বের করুন",
                config_reload: "কনফিগ রিলোড",
                display_message: "বার্তা দেখান",
                restart_app: "রিস্টার্ট",
                // কনসোল থেকে পাঠানো যায় না — লগে দেখা যেতে পারে (en.ts-এর নোট দেখুন)।
                upload_diagnostics: "ডায়াগনস্টিকস আপলোড",
                check_firmware: "ফার্মওয়্যার যাচাই",
                force_offline_sync: "অফলাইন সিংক বাধ্যতামূলক",
                rotate_cert: "সার্টিফিকেট রোটেট",
                rotate_journal_key: "জার্নাল কী রোটেট",
            },
            link: { wifi: "ওয়াই-ফাই", lte: "এলটিই", none: "নেই", standby: "স্ট্যান্ডবাই" },
            cellular: {
                mode: {
                    auto: "অটো (নেটওয়ার্ক-নির্ধারিত)",
                    manual: "ম্যানুয়াল APN",
                    none: "কোনো পলিসি নেই (ফ্যাক্টরি সিড)",
                },
                state: {
                    none: "কোনো প্রোফাইল নেই",
                    provisional: "পরীক্ষাধীন",
                    confirmed: "নিশ্চিত",
                    reverted: "ফিরিয়ে নেওয়া হয়েছে",
                },
                lkg: {
                    none: "কোনো ফলব্যাক নেই",
                    factory: "ফ্যাক্টরি সিড (অপ্রমাণিত)",
                    confirmed: "প্রমাণিত ফলব্যাক",
                },
                lkgHelp: "পুশ করা APN ব্যর্থ হলে ইউনিটটি কোথায় ফিরে যাবে। ফ্যাক্টরি সিড কখনো রাউন্ড-ট্রিপে প্রমাণিত হয়নি, তাই সেখানে নতুন APN পুশ করা সবচেয়ে ঝুঁকিপূর্ণ।",
                provisionalHelp: "পুশ করা প্রোফাইল পরীক্ষাধীন থাকে যতক্ষণ ডিভাইস সেটি দিয়ে ব্যাকএন্ডে পৌঁছে প্রমাণ না করে। না পারলে ডিভাইস প্রায় ১০ মিনিটের মধ্যে নিজেই ফিরিয়ে নেয় এবং একটি ফল্ট জানায়।",
            },
            convergence: {
                label: "কনফিগ",
                converged: "মিলে গেছে",
                pending: "অপেক্ষমাণ",
                unknown: "অজানা",
                help: "ব্যাকএন্ডে এই ডিভাইসের জন্য যে কনফিগারেশন আছে, ডিভাইসটি সেটিই চালাচ্ছে কিনা।",
                unknownHelp: "ডিভাইস কোন কনফিগ ভার্সন চালাচ্ছে তা জানায়নি, বা ব্যাকএন্ড লক্ষ্য নির্ধারণ করতে পারেনি। এটি অমিল নয়।",
            },
            faultFlags: { CELLULAR_APN_REVERTED: "APN ফিরিয়ে নেওয়া হয়েছে" },
            emptyTitle: "এখনো কোনো ডিভাইস রিপোর্ট করেনি",
            emptyBody: "ডিভাইস টেলিমেট্রি পাঠালে বা ব্যাকএন্ডে অনুরোধ সম্পন্ন করলে এখানে দেখা যাবে।",
            colDevice: "ডিভাইস",
            colLocation: "লোকেশন",
            colLiveness: "সংযোগ",
            colLink: "লিংক",
            colCellular: "সেলুলার",
            colState: "অবস্থা",
            colFirmware: "ফার্মওয়্যার",
            colIssued: "ইস্যু",
            colStatus: "স্ট্যাটাস",
            colDetail: "ডিভাইস বিবরণ",
            signal: "সিগন্যাল",
            uptime: "আপটাইম",
            memory: "মেমরি",
            timeTrusted: "ঘড়ি",
            trusted: "নির্ভরযোগ্য",
            untrusted: "অনির্ভরযোগ্য",
            operator: "অপারেটর",
            desiredVersion: "লক্ষ্য ভার্সন",
            reportedVersion: "চলমান ভার্সন",
            cellularState: "পুশ করা প্রোফাইল",
            cellularFallback: "ফলব্যাক",
            cellularApn: "সক্রিয় APN",
            sectionHealth: "হেলথ ও ডায়াগনস্টিকস",
            sectionConfig: "কনফিগারেশন",
            sectionCellular: "সেলুলার পলিসি",
            diag: {
                started: "সর্বশেষ চালু",
                startNumber: "চালু নং {boot}",
                resetReason: {
                    power_on: "পাওয়ার চালু হয়েছে",
                    external: "রিসেট পিন",
                    software: "নিজে রিস্টার্ট করেছে (আপডেট, আগের ইমেজে ফেরা বা রিস্টার্ট কমান্ড)",
                    panic: "ক্র্যাশ করেছে",
                    int_wdt: "আটকে গিয়েছিল (ইন্টারাপ্ট ওয়াচডগ)",
                    task_wdt: "আটকে গিয়েছিল (টাস্ক ওয়াচডগ)",
                    wdt: "আটকে গিয়েছিল (ওয়াচডগ)",
                    deep_sleep: "স্লিপ থেকে জেগেছে",
                    brownout: "সাপ্লাই ভোল্টেজ কমে গিয়েছিল (ব্রাউনআউট)",
                    sdio: "SDIO রিসেট",
                    usb: "USB রিসেট",
                    jtag: "JTAG রিসেট",
                    efuse: "eFuse ত্রুটি",
                    power_glitch: "পাওয়ার গ্লিচ",
                    cpu_lockup: "CPU আটকে গিয়েছিল",
                    unknown: "অজানা কারণ",
                },
                canSell: "বিক্রি করতে পারে",
                sellYes: "হ্যাঁ",
                sellNo: "না",
                saleBlocked: {
                    scratch_unavailable: "বিক্রির রেকর্ড স্টোর পাওয়া যাচ্ছে না",
                    tombstones_full: "অনিষ্পন্ন বিক্রির রেকর্ড বেশি জমে গেছে",
                    open_marker: "একটি বিক্রি এখনো নিষ্পত্তি হচ্ছে",
                    not_calibrated: "ক্যালিব্রেশন নেই",
                    no_price: "দাম সেট নেই",
                    locked: "লক করা",
                    maintenance: "রক্ষণাবেক্ষণে আছে",
                    network_not_ready: "এখনো নেটওয়ার্ক নেই",
                    boot_recovery: "চালুর আগের বিক্রি নিষ্পত্তি হচ্ছে",
                    valve_not_closing: "ভাল্ভ হয়তো বন্ধ হচ্ছে না",
                    updating: "আপডেট ইনস্টল হচ্ছে",
                    backend_not_commissioned: "কমিশন করা হয়নি",
                    backend_no_location: "কোনো লোকেশন দেওয়া নেই",
                    backend_maintenance: "রক্ষণাবেক্ষণের জন্য আটকে রাখা",
                    backend_unknown: "ব্যাকএন্ডের উত্তর অজানা",
                    mode_unreadable: "মোড পড়া যায়নি",
                    card_reader_not_ready: "কার্ড রিডার প্রস্তুত নয়",
                    card_reader_fault: "কার্ড রিডারে ত্রুটি",
                },
                reader: "কার্ড রিডার",
                readerHealth: { starting: "চালু হচ্ছে", operational: "কাজ করছে", recovering: "পুনরুদ্ধার হচ্ছে", fault: "ত্রুটি" },
                readerReady: "প্রস্তুত",
                readerNotReady: "প্রস্তুত নয়",
            },
            incidents: {
                title: "ঘটনার লগ",
                help: "বুথ নিজে যা লিখে রেখে পাঠিয়েছে: প্রতিবার চালু হওয়া ও তার কারণ, কার্ড রিডারের ত্রুটি, মডেমের রিসেট আর হারানো LTE সেশন। বুথ বন্ধ করে আবার চালু করলেও এটি মুছে যায় না।",
                empty: "এই বুথ থেকে কোনো ঘটনা আসেনি।",
                colWhen: "কখন",
                colStart: "চালু",
                colWhat: "কী",
                colDetail: "বিবরণ",
                clockUnsetReported: "ঘড়ি সেট ছিল না; জানানো হয়েছে {when}",
                estimated: "আনুমানিক {when}",
                estimatedHelp: "তখনো ঘড়ি সেট হয়নি; একই চালুর অন্য রেকর্ড বা টেলিমেট্রি থেকে হিসাব করা।",
                modemPowerUp: "মডেম চালু করা হয়েছে",
                afterUptime: "চালু নং {boot}-এর {uptime} পরে",
                older: "আরও পুরোনো দেখুন",
                kind: {
                    boot: "চালু হয়েছে",
                    reader: "কার্ড রিডারে ত্রুটি",
                    modem_reset: "বুথ মডেম রিসেট করেছে",
                    modem_boot: "মডেম নিজে রিস্টার্ট হয়েছে",
                    ppp_lost: "LTE সেশন হারিয়েছে",
                },
                otherKind: "অন্য রেকর্ড",
                cause: {
                    no_ack: "একটি সার্চের সাড়া মেলেনি",
                    refused: "রিকনফিগারেশন প্রত্যাখ্যাত হয়েছে",
                    path_lost: "রিডার নিজে রিসেট হয়েছিল",
                    unanswered: "একটি কমান্ডের উত্তর আসেনি",
                    link: "লিংক ত্রুটি",
                    chip: "চিপ ত্রুটি",
                },
                pulse: {
                    unsaid: "কারণ লেখা নেই",
                    silent: "মডেম সাড়া দেওয়া বন্ধ করেছিল",
                    radio_dead: "রেডিও বারবার নেটওয়ার্কে রেজিস্টার হতে পারেনি",
                    sim: "সিম প্রস্তুত ছিল না",
                    path: "সেশনে কোনো ডেটা আসা-যাওয়া করছিল না",
                },
                count: "এই চালুতে {n} বার",
                board: "বোর্ড {c} °C",
                modemTemp: "মডেম {c} °C",
                supply: "মডেম সাপ্লাই {v} V (সর্বনিম্ন {min} V)",
                sinceModem: "শেষ মডেম রিসেটের {t} পরে",
                readerCounts: "রিডার রিসেট {resets}, উত্তরহীন {unanswered}, লিংক ত্রুটি {link}, চিপ ত্রুটি {chip}",
            },
            sectionCommands: "কমান্ড ইতিহাস",
            sectionIssue: "কমান্ড পাঠান",
            commandLabel: "কমান্ড",
            reasonLabel: "কারণ",
            reasonHint: "অডিট ট্রেইলে রাখা হয় — কী নয়, কেন তা লিখুন।",
            messageLabel: "বার্তা",
            messageAsciiError: "ডিভাইস স্ক্রিনে শুধু সাধারণ ইংরেজি অক্ষর, সংখ্যা ও যতিচিহ্ন দেখানো যায় — “{char}” সরান।",
            journalLabel: "অফলাইন জার্নাল",
            journalClear: "সব সিংক হয়েছে",
            journalUnsynced: "{count}টি সিংক হয়নি",
            messageHint: "ডিভাইসের স্ক্রিনে দেখানো হবে। শুধু ASCII, সর্বোচ্চ ৬৪ অক্ষর।",
            issueAction: "কমান্ড পাঠান",
            issued: "কমান্ড পাঠানো হয়েছে। নিচে স্ট্যাটাস দেখুন।",
            confirmTitle: "এই কমান্ডটি পাঠাবেন?",
            confirmBody: "{command} এই ডিভাইসে পাঠানো হবে এবং আপনার অ্যাকাউন্টের বিপরীতে নথিভুক্ত হবে। কারণ: {reason}",
            inFlight: "চলমান",
            noCommands: "এখনো কোনো কমান্ড নেই।",
            filterStatus: "স্ট্যাটাস",
            filterAll: "সব",
            stampIssued: "ইস্যু",
            // "পাঠানো" (sent) — en.ts-এর নোট দেখুন।
            stampDelivered: "পাঠানো",
            stampAccepted: "গৃহীত",
            stampOutcome: "ফলাফল",
            deliveryFailedHelp: "সময়সীমার মধ্যে ডিভাইসে পৌঁছায়নি। ইউনিট অনলাইনে এলে আবার পাঠান।",
            executionTimeoutHelp: "ডিভাইস গ্রহণ করেছিল, কিন্তু কোনো ফলাফল জানায়নি। ইউনিটটি দেখুন।",
        },
        // ক্যালিব্রেশন। সংখ্যাগুলো দুই ভাষাতেই পশ্চিমা অঙ্কে থাকে।
        calibration: {
            trialsCaption: "এই ক্যালিব্রেশনের প্রতিটি পোর",
            queueSub: "{count}টি সিদ্ধান্তের অপেক্ষায়। প্রতিটির পেছনে একজন টেকনিশিয়ান অপেক্ষা করছেন।",
            queueSubEmpty: "আপনার সিদ্ধান্তের অপেক্ষায় কিছু নেই।",
            loading: "প্রস্তাব লোড হচ্ছে",
            reviewAction: "দেখুন",
            waitingFor: "{duration} ধরে অপেক্ষায়",
            proposalDesc: "অনুমোদন করলে এই বুথের প্রতিটি বিক্রির হিসাব এই ফ্যাক্টরেই হবে।",
            validDaysError: "{min} থেকে {max} দিনের মধ্যে একটি পূর্ণসংখ্যা দিন।",
            approveDoesNotChange: "আর কিছুই বদলায় না। ডিভাইস স্ট্যাটাস, দাম, লোকেশন ও শিফট শর্ত এই পর্দায় দেখা যায় না।",
            historyHint: "সব রেকর্ড, প্রত্যাখ্যাতগুলোসহ",
            pageTitle: "ক্যালিব্রেশন",
            sectionTitle: "ক্যালিব্রেশন",
            state: "অবস্থা",
            stateLabel: {
                valid: "বৈধ",
                expiringSoon: "শীঘ্রই মেয়াদ শেষ",
                expired: "মেয়াদ শেষ",
                not_yet_effective: "এখনও কার্যকর নয়",
                missing: "কখনও ক্যালিব্রেট করা হয়নি",
            },
            notBlocking: "ক্যালিব্রেশন এই বুথকে আটকাচ্ছে না। অন্যান্য পরীক্ষা এখানে দেখা যায় না।",
            blocking: "ক্যালিব্রেশন এই বুথকে আটকে রেখেছে।",
            neverCalibrated: "এই বুথ কখনও ক্যালিব্রেট করা হয়নি।",
            neverCalibratedHelp: "টেকনিশিয়ান বুথে গিয়ে ক্যালিব্রেটেড পাত্র দিয়ে মাপার আগে এটি পানি বিক্রি করতে পারবে না।",
            sessionOpen: "{who} এই বুথে একটি ক্যালিব্রেশন সেশন চালু রেখেছেন, শুরু {when}।",
            aTechnician: "একজন টেকনিশিয়ান",
            activeHeading: "বর্তমান ফ্যাক্টর",
            proposedHeading: "প্রস্তাবিত ফ্যাক্টর",
            proposalHeading: "সিদ্ধান্তের অপেক্ষায়",
            noProposal: "সিদ্ধান্তের অপেক্ষায় কিছু নেই।",
            lastRejectedHeading: "সর্বশেষ বাতিল হওয়া চেষ্টা",
            lastRejectedBody: "{version} {when} তারিখে বাতিল হয়েছে: {reason}",
            versionCode: "ভার্সন",
            factor: "ফ্যাক্টর",
            perLitre: "পালস / লিটার",
            currently: "বর্তমানে {ml} mL/pulse · {ppl} পালস / লিটার",
            quality: "পুনরাবৃত্তিযোগ্যতা",
            acrossTrials: "{n} টি গৃহীত ঢালার মধ্যে বিস্তার",
            acceptedOfAttempts: "{attempts} টি ঢালার মধ্যে {accepted} টি গৃহীত",
            noEvidence: "কোনো ট্রায়াল ডেটা নেই — এই রেকর্ড বুথে মাপা হয়নি, সরাসরি লেখা হয়েছে।",
            method: "পদ্ধতি",
            methodLabel: { single_close: "একবারে বন্ধ", creep: "দাগ পর্যন্ত ধীরে" },
            referenceLabel: { vessel: "ক্যালিব্রেটেড পাত্র", scale: "দাঁড়িপাল্লা" },
            valve: "ভাল্ভ",
            valveDetail: "{close} ms বন্ধ · {coast} mL কোস্ট · {flow} পালস/সে",
            measuredBy: "মেপেছেন",
            validity: "বৈধতা",
            firmware: "ফার্মওয়্যার",
            decidedBy: "সিদ্ধান্ত নিয়েছেন",
            deviationHelp: "বর্তমান ফ্যাক্টরের তুলনায়",
            noPreviousFactor: "তুলনা করার মতো আগের কোনো ফ্যাক্টর নেই।",
            showTrials: "প্রতিটি ঢালা দেখুন",
            noTrials: "কোনো ঢালা রেকর্ড করা হয়নি।",
            trialIndex: "#",
            trialKind: "ঢালা",
            trialTarget: "লক্ষ্য",
            trialMeasured: "মাপা",
            trialPulses: "পালস",
            trialCloses: "বন্ধ",
            trialFactor: "mL/pulse",
            trialVerdict: "রায়",
            kind: { learning: "শেখার ঢালা", trial: "ট্রায়াল", rejected_trial: "বাতিল" },
            verdict: { at_mark: "দাগ বরাবর", short: "কম", over: "বেশি" },
            learningExcluded: "পুল করা হিসাব থেকে বাদ — এটি নকশা অনুযায়ীই একাধিকবার বন্ধ হয়।",
            multiClose: "· একবারে বন্ধ নয়",
            decisionTitle: "সিদ্ধান্ত",
            approveAction: "অনুমোদন",
            rejectAction: "বাতিল",
            decided: "রেকর্ড হয়েছে।",
            reasonLabel: "কারণ",
            reasonHint: "অডিট ট্রেইলে রাখা হয় — কী নয়, কেন লিখুন। বাতিল করতে আবশ্যক।",
            rejectNeedsReason: "বাতিল করতে কারণ আবশ্যক: টেকনিশিয়ানকে পুরো কাজটি আবার করতে হবে এবং তিনি এটি পড়বেন।",
            validDaysLabel: "বৈধতা (দিন)",
            validDaysHint: "মাপার সময় থেকে নয়, অনুমোদনের সময় থেকে গোনা হয়।",
            confirmApproveTitle: "এই ক্যালিব্রেশন অনুমোদন করবেন?",
            confirmApproveBody: "{version} এই বুথের প্রতিটি বিক্রির হিসাবের ভিত্তি হবে, এখন থেকে {days} দিনের জন্য বৈধ।",
            approveUnblocksCalibration: "ক্যালিব্রেশন আর বিক্রি আটকাবে না, এবং অন্য কোনো মেইনটেন্যান্স লক অবশিষ্ট নেই।",
            approveLeavesLocks: "ক্যালিব্রেশন আর বিক্রি আটকাবে না, তবে এই বুথ লক থাকবে: {causes}।",
            confirmRejectTitle: "এই ক্যালিব্রেশন বাতিল করবেন?",
            confirmRejectBody: "বুথ তার বর্তমান ফ্যাক্টরই রাখবে — এটি কীভাবে চলছে তার কিছুই বদলাবে না। টেকনিশিয়ানকে আবার মাপতে হবে, এবং তিনি দেখবেন: {reason}",
            technicianCannotDecide: "ক্যালিব্রেশন অনুমোদন করেন ম্যানেজার বা অ্যাডমিন। আপনি এখানে মাপ ও তার প্রমাণ দেখতে পারবেন।",
            settledByYou: "আপনি {when} সময়ে এই ক্যালিব্রেশন ইতিমধ্যেই {status}। আগের উত্তরটি হারিয়ে গিয়েছিল।",
            settledByOther: "এই ক্যালিব্রেশন {when} সময়ে {who} ইতিমধ্যেই {status}।",
            rejectionReasonWas: "উল্লেখিত কারণ: {reason}",
            status: {
                proposed: "সিদ্ধান্তের অপেক্ষায়",
                active: "অনুমোদন করেছেন",
                superseded: "প্রতিস্থাপিত",
                rejected: "বাতিল করেছেন",
                revoked: "প্রত্যাহৃত",
                failed: "ব্যর্থ হিসেবে রেকর্ড",
            },
            gate: { min_trials: "গৃহীত ঢালা", max_spread_bp: "বিস্তার" },
            warning: {
                largeDeviation: "এটি হিসাবের ফ্যাক্টর 5% এর বেশি বদলে দিচ্ছে।",
                spreadNearGate: "ঢালাগুলোর মধ্যে স্বাভাবিকের চেয়ে বেশি পার্থক্য — বাতিল হওয়ার সীমার কাছাকাছি।",
                replacesWorkingFactor: "এই বুথে ইতিমধ্যেই একটি বৈধ ক্যালিব্রেশন আছে। অনুমোদন করলে এমন একটি ফ্যাক্টর বদলে যাবে যার মেয়াদ শেষ হয়নি বা যা অনুপস্থিত নয়।",
                staleProposal: "এই মাপ কয়েক দিন আগে নেওয়া হয়েছিল।",
            },
            lockCause: {
                cleaning_overdue: "পরিষ্কারের সময় পেরিয়েছে",
                filter_overdue: "ফিল্টারের সময় পেরিয়েছে",
                water_test_overdue: "পানি পরীক্ষার সময় পেরিয়েছে",
                water_test_failed: "পানি পরীক্ষা ব্যর্থ",
                calibration_expired: "ক্যালিব্রেশনের মেয়াদ শেষ",
                calibration_missing: "কখনও ক্যালিব্রেট করা হয়নি",
                calibration_failed: "ক্যালিব্রেশন ব্যর্থ",
                inspection_required: "পরিদর্শন প্রয়োজন",
                fault: "ত্রুটি",
                manual: "হাতে লক করা",
            },
            historyTitle: "ক্যালিব্রেশনের ইতিহাস",
            historyEmpty: "এই বুথের কোনো ক্যালিব্রেশন রেকর্ড নেই।",
            colStatus: "অবস্থা",
            colWhen: "কখন",
            showEvidence: "ঢালাগুলো দেখুন",
            hideEvidence: "ঢালাগুলো লুকান",
            queueTitle: "ক্যালিব্রেশন অনুমোদন",
            queueEmpty: "সিদ্ধান্তের অপেক্ষায় কিছু নেই।",
            queueEmptyHelp: "টেকনিশিয়ান জমা দেওয়ামাত্র বুথের ক্যালিব্রেশন এখানে আসবে।",
            awaitingDecision: "সিদ্ধান্তের অপেক্ষায়",
            colDevice: "বুথ",
            colLocation: "লোকেশন",
            colChange: "পরিবর্তন",
            colSpread: "বিস্তার",
            colTrials: "ঢালা",
            colTechnician: "মেপেছেন",
            colProposed: "জমা",
        },
        maintenance: {
            dueBoardSub: "আপনার দেখা প্রতিটি বুথ, সবচেয়ে জরুরিটি আগে — ক্রমটি ব্যাকএন্ডের বিচার।",
            dueBoardEmptyHelp: "কমিশন হওয়ার পর বুথগুলো এখানে দেখা যাবে।",
            loading: "বুথ লোড হচ্ছে",
            summary: {
                locked: "হোল্ডে",
                lockedSub: "না ছাড়া পর্যন্ত বিক্রি বন্ধ",
                calibration: "ক্যালিব্রেশন আটকাচ্ছে",
                calibrationSub: "মেয়াদ শেষ বা কখনও মাপা হয়নি",
                overdue: "সময় পেরোনো কাজ",
                overdueSub: "পরিষ্কার, ফিল্টার বা পানি পরীক্ষা",
                awaiting: "সিদ্ধান্তের অপেক্ষায়",
                awaitingSub: "একজন টেকনিশিয়ান অপেক্ষা করছেন",
            },
            moreLocks: "+আরও {count}টি",
            dueBoardTitle: "মেইনটেন্যান্স",
            dueBoardEmpty: "দেখানোর মতো কোনো বুথ নেই।",
            colDevice: "বুথ",
            colLocation: "লোকেশন",
            colCalibration: "ক্যালিব্রেশন",
            colLocks: "লক",
            colDue: "পরবর্তী সময়",
            noLocks: "নেই",
            overdue: "{what} সময় পেরিয়েছে",
            cleaning: "পরিষ্কার",
            filter: "ফিল্টার",
            waterTest: "পানি পরীক্ষা",
        },
        locks: {
            heldDescription: "কোনো হোল্ড সক্রিয় থাকলে এই বুথ বিক্রি করবে না।",
            clearDescription: "কোনো মেইনটেন্যান্স হোল্ড এই বুথকে আটকাচ্ছে না।",
            heldCount: "{count}টি সক্রিয়",
            notHeld: "হোল্ড নেই",
            assertNeedsReason: "কারণ লেখা বাধ্যতামূলক — পরের জন এটিই পড়বেন।",
            title: "লক",
            none: "এই বুথে কোনো সক্রিয় লক নেই।",
            colCause: "কারণ",
            colSource: "কে দিয়েছে",
            colSince: "কখন থেকে",
            colReason: "কারণ",
            source: { auto: "স্বয়ংক্রিয়", manual: "হাতে" },
            clearAction: "মুক্ত করুন",
            clearTitle: "এই লক মুক্ত করবেন?",
            confirmClear: "{cause} এর জন্য দেওয়া লক তুলে নেওয়া হবে। অন্য কোনো লক থাকলে তা বহাল থাকবে।",
            assertTitle: "এই বুথ লক করুন",
            assertAction: "লক করুন",
            assertHelp: "শুধু সেই কারণগুলো যা একজন মানুষ বিচার করেন। মেয়াদ পেরোনোর লক রেকর্ড থেকেই স্বয়ংক্রিয়ভাবে ওঠে।",
            confirmAssert: "কেউ মুক্ত না করা পর্যন্ত এই বুথ {cause} এর জন্য আটকে থাকবে।",
            reasonHint: "অডিট ট্রেইলে রাখা হয় — কী নয়, কেন লিখুন।",
            needsCorrectiveRecord: "মুক্ত করার আগে একটি উত্তীর্ণ রেকর্ড প্রয়োজন।",
            preconditionWarning: "সংশোধনী অবস্থা রেকর্ডে না থাকা পর্যন্ত এই কারণটি মুক্ত করা যায় না। তা ছাড়া অনুরোধ বাতিল হবে।",
            preconditionFailed: "বাতিল: সংশোধনী অবস্থা এখনও রেকর্ডে নেই। আগে উত্তীর্ণ রেকর্ডটি লিখুন, তারপর লক মুক্ত করুন।",
        },
        attachments: {
            photoAlt: "এই রেকর্ডে যুক্ত ছবি",
            addPhoto: "এই রেকর্ডে ছবি যোগ করুন",
            unavailable: "এই ডিপ্লয়মেন্টে ছবি সংযুক্তি চালু নেই।",
            pending: "সংরক্ষিত, আপলোড হয়নি",
            resumable: "আপলোড শেষ হয়নি। আবার ফাইলটি বেছে নিলে সেখান থেকেই চলবে — নতুন রেকর্ড তৈরি হবে না।",
            uploadFailed: "আপলোড সম্পূর্ণ হয়নি। একই ফাইল আবার চেষ্টা করুন।",
            discard: "এই আপলোড বাতিল করুন",
            step: {
                creating: "সংরক্ষণ করা হচ্ছে…",
                uploading: "আপলোড হচ্ছে…",
                confirming: "ফাইলটি পৌঁছেছে কিনা যাচাই হচ্ছে…",
            },
        },
        records: {
            sectionTitle: "নিয়মিত রেকর্ড",
            sectionDesc: "রেকর্ড জমা দিলে সংশ্লিষ্ট সময়-পেরোনো হোল্ড একই সঙ্গে উঠে যায়।",
            historyTitle: "সাম্প্রতিক রেকর্ড",
            lastRecorded: "সর্বশেষ রেকর্ড {when}, করেছেন {who}",
            nextDueOn: "পরবর্তী সময় {when}",
            unknownPerformer: "নাম লেখা হয়নি এমন কেউ",
            notesHint: "পরের টেকনিশিয়ানের যা জানা দরকার।",
            lifeDaysHint: "এই ফিল্টার কত দিন চলবে বলে ধরা হচ্ছে।",
            kind: {
                cleaning: "পরিষ্কার",
                "filter-change": "ফিল্টার পরিবর্তন",
                "water-test": "পানি পরীক্ষা",
                inspection: "পরিদর্শন",
            },
            none: "এখনও কিছু রেকর্ড করা হয়নি।",
            filed: "রেকর্ড হয়েছে।",
            fileTitle: "এই কাজ রেকর্ড করুন",
            fileAction: "রেকর্ড জমা দিন",
            colPerformed: "সম্পন্ন",
            colBy: "কে করেছেন",
            colNextDue: "পরবর্তী সময়",
            colResult: "ফলাফল",
            colPhotos: "ছবি",
            result: { pass: "উত্তীর্ণ", fail: "ব্যর্থ" },
            performerLabel: "কাজটি কে করেছেন",
            performerSelf: "আমি — {name}",
            performerOther: "অন্য কেউ",
            performerHint: "আপনার স্টাফ অ্যাকাউন্টের নামে রেকর্ড হবে।",
            performerAdminHint: "অ্যাডমিনরা যিনি কাজটি করেছেন তাঁর নাম দিয়ে রেকর্ড করেন।",
            requiredMark: "(আবশ্যক)",
            stillNeeded: "এখনও প্রয়োজন: {fields}",
            staffIdLabel: "স্টাফ সদস্য",
            staffIdHint: "যিনি কাজটি করেছেন তাঁর স্টাফ আইডি।",
            otherLabel: "অথবা বাইরের কারও নাম",
            otherHint: "স্টাফ সদস্য ছাড়া অন্য কেউ কাজটি করলে এটি ব্যবহার করুন।",
            performedBy: { nameRequired: "কাজটি কে করেছেন তা লিখুন।" },
            notesLabel: "নোট",
            reasonLabel: "কারণ",
            reasonHint: "অডিট ট্রেইলে রাখা হয় — কী নয়, কেন লিখুন।",
            nextDueHint: "আবার কবে দরকার হবে। রেকর্ড জমা দিলে এর মেয়াদ পেরোনোর লক মুক্ত হয়ে যায়।",
            failLocksBooth: "ব্যর্থ পরীক্ষা বুথটিকে আটকে রাখে, যতক্ষণ না একটি উত্তীর্ণ পরীক্ষা রেকর্ড হয়।",
            field: {
                next_due_at: "পরবর্তী সময়",
                cleaning_type: "পরিষ্কারের ধরন",
                filter_type: "ফিল্টারের ধরন",
                filter_serial: "ফিল্টার সিরিয়াল",
                expected_life_days: "প্রত্যাশিত আয়ু (দিন)",
                method: "পদ্ধতি",
                issue_type: "সমস্যার ধরন",
                findings: "যা পাওয়া গেল",
                action_taken: "যা করা হয়েছে",
                test_result: "পরীক্ষার ফলাফল",
                next_action: "পরবর্তী পদক্ষেপ",
            },
        },
        firmware: {
            title: "ফার্মওয়্যার",
            sub: "স্বাক্ষরিত রিলিজ এবং বুথে সেগুলোর রোলআউট। রিলিজ আসে শুধু স্বাক্ষরিত ইমপোর্টের মাধ্যমে; রোলআউট শুরু হয় এখান থেকে।",
            newRollout: "নতুন রোলআউট",
            loading: "ফার্মওয়্যার লোড হচ্ছে",
            gateBanner: "{version}-এর রোলআউট নিজে থেকে থেমে গেছে: {detail}",
            openRollout: "রোলআউটটি খুলুন",
            rolloutsTitle: "রোলআউট",
            rolloutsHelp: "সবচেয়ে নতুনটি আগে। কোনো ধাপে অনুমোদিত সংখ্যার চেয়ে বেশি ব্যর্থতা হলে রোলআউট নিজেই থেমে যায়।",
            noRollouts: "এখনও কোনো রোলআউট নেই",
            noRolloutsHelp: "নিচের রিলিজের তালিকা থেকে একটি রিলিজ রোলআউট করুন।",
            releasesTitle: "রিলিজ",
            releasesHelp: "সবচেয়ে নতুনটি আগে। নতুন রোলআউট বন্ধ করতে রিলিজটি ডিপ্রিকেট করুন; চিরতরে প্রত্যাহার করতে রিভোক করুন।",
            noReleases: "এখনও কোনো রিলিজ নেই",
            noReleasesHelp: "রিলিজ আসে স্বাক্ষরিত ইমপোর্টের মাধ্যমে (ল্যাবে: dpci ota)।",
            colVersion: "ভার্সন",
            colBuild: "বিল্ড",
            colStatus: "স্ট্যাটাস",
            colStage: "ধাপ",
            colBooths: "বুথ",
            colBooth: "বুথ",
            colStarted: "শুরু",
            colImported: "ইমপোর্ট",
            colActions: "কাজ",
            colState: "অবস্থা",
            colAttempts: "চেষ্টা",
            colDownloaded: "ডাউনলোড",
            colReason: "কারণ",
            colUpdated: "হালনাগাদ",
            colWhen: "কখন",
            colEvent: "ঘটনা",
            colOutcome: "ফলাফল",
            stageOf: "{count}টির মধ্যে {index} · {name}",
            rollOut: "রোলআউট করুন",
            noBooths: "কোনো বুথ নেই",
            funnel: {
                waiting: "{n}টি অপেক্ষায়",
                underWay: "{n}টি চলমান",
                proven: "{n}টি প্রমাণিত",
                failed: "{n}টি ব্যর্থ",
                wentBack: "{n}টি ফিরে গেছে",
                closed: "{n}টি বন্ধ",
                other: "{n}টি অন্যান্য",
            },
            rolloutStatus: { active: "চলছে", paused: "থামানো", aborted: "বাতিল", completed: "সম্পন্ন" },
            byGate: "(গেটের দ্বারা)",
            byOperator: "(অপারেটরের দ্বারা)",
            releaseStatus: { available: "পাওয়া যায়", deprecated: "ডিপ্রিকেটেড", revoked: "রিভোকড" },
            attemptState: {
                pending: "অপেক্ষায়",
                offered: "অফার করা হয়েছে",
                downloading: "ডাউনলোড হচ্ছে",
                staged: "বদলের জন্য প্রস্তুত",
                applying: "বদলাচ্ছে",
                proven: "প্রমাণিত",
                failed: "ব্যর্থ",
                rolled_back: "রোলব্যাক হয়েছে",
                reverted: "ফিরে গেছে",
                cancelled: "বাতিল",
                skipped: "বাদ পড়েছে",
            },
            policy: { any: "যেকোনো লিংক", wifi_preferred: "Wi-Fi অগ্রাধিকার", wifi_only: "শুধু Wi-Fi" },
            policyHelp: {
                any: "বুথ যে লিংকে আছে, Wi-Fi বা LTE, সেটিতেই।",
                wifi_preferred: "Wi-Fi-তে; LTE-তে শুধু কয়েক ঘণ্টা Wi-Fi না থাকলে।",
                wifi_only: "শুধু Wi-Fi-তে: LTE-তে থাকা বুথ অপেক্ষা করে।",
            },
            rolloutTitle: "{version}-এর রোলআউট",
            rolloutSub: "{when}-এ {who} শুরু করেছেন: {reason}",
            gateTitle: "এর গেট এটিকে থামিয়েছে",
            gateHelp: "কারণ লিখে আবার চালু করুন — ব্যর্থতাগুলো বোঝা গেলে ধাপের সীমা বাড়িয়ে — অথবা বাতিল করুন।",
            pausedHelp: "একজন অপারেটর থামিয়েছেন: আবার চালু না হওয়া পর্যন্ত নতুন কিছু অফার করা হবে না, আর বুথগুলো যা ডাউনলোড করেছে তা রাখবে।",
            factsTitle: "রোলআউট",
            release: "রিলিজ",
            download: "ডাউনলোড",
            idle: "বদলের আগে নিরিবিলি সময়",
            inFlight: "একসাথে কয়টি বুথ",
            urgent: "জরুরি",
            urgentYes: "হ্যাঁ: ইমেজটি গার্ড উইন্ডোতে থাকলেও বুথ এটি নিতে পারে",
            no: "না",
            stagesTitle: "ধাপ",
            stageCurrent: "বর্তমান",
            stageNamed: "নির্দিষ্ট {count}টি বুথ",
            stageAll: "বাকি সব বুথ",
            stageGateNone: "কোনো গেট নেই",
            stageGateZero: "প্রথম ব্যর্থতাতেই রোলআউট থেমে যায়",
            stageGate: "{n}টি ব্যর্থতা অনুমোদিত; এর পরেরটিতে রোলআউট থেমে যায়",
            stageSoak: "পরের ধাপের আগে অন্তত {duration} চলে",
            boothsTitle: "বুথ",
            actionsTitle: "কাজ",
            pause: "থামান",
            pauseTitle: "এই রোলআউট থামাবেন?",
            pauseConsequence: "আবার চালু না হওয়া পর্যন্ত কোনো বুথকে এটি অফার করা হবে না। বুথগুলো যা ডাউনলোড করেছে তা রাখবে, আর যে বুথ ইতিমধ্যে বদলাচ্ছে সেটি শেষ করবে; তার ফলাফল গোনা হবে।",
            resume: "আবার চালু করুন",
            resumeTitle: "এই রোলআউট আবার চালু করবেন?",
            resumeConsequence: "বুথগুলো যেখানে থেমেছিল সেখান থেকে আবার অফার পাবে।",
            resumeGateWarning: "এটিকে গেট থামিয়েছে: একই সীমায় চালু করলে গেটের পরের রানে আবার থেমে যাবে।",
            resumeLimit: "এই ধাপে অনুমোদিত ব্যর্থতা",
            resumeLimitHelp: "এখন {n}। একই রাখতে খালি রাখুন; এ পর্যন্ত ব্যর্থতাগুলো বোঝা গেলে তবেই বাড়ান।",
            advance: "পরের ধাপ শুরু করুন",
            advanceTitle: "পরের ধাপ শুরু করবেন?",
            advanceConsequence: "পরের ধাপ শুরু হবে: {stage}। এর বুথগুলো রিলিজটি অফার পাবে।",
            advanceForce: "বর্তমান ধাপে কোনো বুথ এখনও চলমান থাকলে বা সোক টাইম পূর্ণ না হলেও শুরু করুন",
            abort: "বাতিল করুন",
            abortTitle: "এই রোলআউট বাতিল করবেন?",
            abortConsequence: "যে বুথগুলো এখনও অফার পায়নি সেগুলো বাতিল হবে, আর চলমান অফারগুলো প্রতিটি বুথের পরের চেকে প্রত্যাহার হবে। বাতিল রোলআউট আর চালু করা যায় না।",
            abortRevert: "যে বুথগুলো এটি ইনস্টল করেছে এবং ফিরে যেতে পারে, সেগুলোকেও ফিরিয়ে পাঠান",
            revertedCount: "{n}টি বুথ ফিরিয়ে পাঠানো হয়েছে।",
            reasonLabel: "কারণ",
            reasonHint: "অডিট ট্রেইলে রাখা হয় — কী নয়, কেন লিখুন।",
            confirmAudit: "এই কারণসহ আপনার নামে রেকর্ড হবে।",
            stillNeeded: "এখনও দরকার: {fields}",
            releaseTitle: "রিলিজ {version}",
            releaseSub: "{when}-এ {who} ইমপোর্ট করেছেন",
            revokedHelp: "রিভোকড: এটি রোলআউট করা যায় না, আর এর রোলআউটগুলো বাতিল হয়েছে। যে বুথগুলো এটি ইনস্টল করেছে, সেগুলো ফিরিয়ে পাঠানো বা নতুন রিলিজ আসা পর্যন্ত এটি রাখবে।",
            deprecatedHelp: "ডিপ্রিকেটেড: এটি নতুন করে রোলআউট করা যায় না; আগের রোলআউটগুলো চলবে।",
            releaseFacts: "রিলিজ",
            buildId: "বিল্ড (ELF sha256)",
            image: "ইমেজ",
            imageSha: "ইমেজ sha256",
            hwRevs: "হার্ডওয়্যার রিভিশন",
            layout: "পার্টিশন লেআউট",
            proveWithin: "ব্যাকএন্ডে পৌঁছানোর সময়সীমা",
            guard: "আগের ইমেজটি যতক্ষণ রাখা হয়",
            keyId: "স্বাক্ষরের কী",
            manifestTitle: "স্বাক্ষরিত ম্যানিফেস্ট",
            manifestHelp: "হুবহু যেমন স্বাক্ষর করা হয়েছে; পাশের তথ্যগুলো ইমপোর্টের সময় এখান থেকে নেওয়া।",
            deprecate: "ডিপ্রিকেট করুন",
            deprecateTitle: "এই রিলিজ ডিপ্রিকেট করবেন?",
            deprecateConsequence: "এটি আর নতুন করে রোলআউট করা যাবে না। আগের রোলআউটগুলো চলবে।",
            revoke: "রিভোক করুন",
            revokeTitle: "এই রিলিজ রিভোক করবেন?",
            revokeConsequence: "চিরতরে প্রত্যাহার: এর চলমান রোলআউটগুলো বাতিল হবে এবং অফারগুলো প্রত্যাহার হবে। যে বুথগুলো এটি ইনস্টল করেছে, সেগুলো ফিরিয়ে পাঠানো বা নতুন রিলিজ আসা পর্যন্ত এটি রাখবে।",
            newTitle: "নতুন রোলআউট",
            newSub: "একটি রিলিজ, যে বুথগুলো আগে নেবে, আর সেগুলো ব্যর্থ হলে রোলআউট থামানোর গেট।",
            noAvailable: "কোনো রিলিজ রোলআউট করা যাবে না: কোনোটিই পাওয়া যায় না।",
            fieldRelease: "রিলিজ",
            fieldReleaseNone: "একটি রিলিজ বেছে নিন",
            fieldBooths: "বুথ",
            fieldBoothsHelp: "প্রথম ধাপ: যে বুথগুলো কেউ নজরে রাখতে পারেন। বাকি সব বুথ দ্বিতীয় ধাপে আসতে পারে।",
            boothsFilter: "সিরিয়াল বা লোকেশন দিয়ে খুঁজুন",
            boothsSelected: "{n}টি বাছাই করা",
            offline: "অফলাইন",
            gateTitleNew: "গেট",
            fieldMaxFailures: "নিজে থেকে থামার আগে অনুমোদিত ব্যর্থতা",
            fieldMaxFailuresHelp: "0: প্রথম ব্যর্থতাতেই রোলআউট থেমে যায়। ব্যর্থতা মানে কোনো বুথ ব্যর্থ হয়েছে, রোলব্যাক হয়েছে, নিজে থেকে ফিরে গেছে, অথবা বদলের দুই ঘণ্টা পরও নীরব।",
            fieldThenAll: "এরপর বাকি সব বুথ",
            fieldThenAllHelp: "বাকি সব সক্রিয় বুথ নিয়ে একটি দ্বিতীয় ধাপ; প্রথম ধাপ তার সোক টাইম পূর্ণ করলে একজন অপারেটর তা শুরু করেন।",
            fieldSoak: "পরের ধাপ শুরুর আগে প্রথম ধাপ কত ঘণ্টা চলবে",
            fieldAllMaxFailures: "দ্বিতীয় ধাপে অনুমোদিত ব্যর্থতা",
            deliveryTitle: "পৌঁছানো",
            fieldPolicy: "ডাউনলোড",
            fieldIdle: "বদলের আগে বুথ কত মিনিট নিরিবিলি থাকবে",
            fieldUrgent: "জরুরি",
            fieldUrgentHelp: "বুথের চলমান ইমেজটি গার্ড উইন্ডোতে থাকলেও বুথ এটি নিতে পারে। নিয়মিত রিলিজের জন্য নয়, সংশোধনের জন্য।",
            start: "রোলআউট শুরু করুন",
            startTitle: "এই রোলআউট শুরু করবেন?",
            startConsequence: "{version} এখন {count}টি বুথে অফার করা হবে।",
            startThenAll: "আপনি পরের ধাপ শুরু করলে বাকি সব বুথ অনুসরণ করবে।",
            problem: {
                release: "একটি রিলিজ",
                booths: "অন্তত একটি বুথ",
                max_failures: "ব্যর্থতার একটি পূর্ণসংখ্যা",
                soak: "0 থেকে 720 ঘণ্টার সোক টাইম",
                idle: "পূর্ণ মিনিটে নিরিবিলি সময়",
                reason: "একটি কারণ",
            },
            tab: "ফার্মওয়্যার",
            imagesTitle: "ইমেজ",
            running: "চলছে",
            previous: "আগের",
            canGoBack: "এটিতে ফিরে যেতে পারে",
            cannotGoBack: "এখন এটিতে ফিরে যেতে পারে না",
            reported: "জানিয়েছে",
            noReport: "এই বুথ এখনও তার ফার্মওয়্যার জানায়নি।",
            safeMode: "নিরাপদ মোড: এই বুথের ইমেজ পরপর {crashes} বার চালু হওয়ার পর ক্র্যাশ করেছে, আর ফিরে যাওয়ার মতো কোনো ইমেজ নেই। এটি কিছু বিক্রি করে না, আর প্রতি ৫ মিনিটে সমাধানের খোঁজ নেয়: এটিতে এমন একটি রিলিজ রোলআউট করুন যা ক্র্যাশ করে না।",
            sendBackTitle: "ফিরিয়ে পাঠানো",
            sendBackHelp: "যে বুথের আপডেট ঠিকমতো চলছে না তার জন্য। যে রোলআউট থেকে এসেছে, সেটি অন্য বুথগুলোর জন্য চলবে।",
            sendBack: "{version}-এ ফিরিয়ে পাঠান",
            sendBackDialog: "এই বুথ ফিরিয়ে পাঠাবেন?",
            sendBackConsequence: "পরের চেকে, কয়েক মিনিটের মধ্যে, কোনো ঢালা কাটা না পড়ার মতো সময়ে এটি {version}-এ ফিরে যাবে এবং কেমন হলো জানাবে।",
            revertBlock: {
                no_report: "ফিরিয়ে পাঠানো যাবে না: এটি এখনও তার ফার্মওয়্যার জানায়নি।",
                pending: "এই বুথ ফিরিয়ে পাঠানোর একটি অনুরোধ ইতিমধ্যে চলছে।",
                not_revertible: "এখন ফিরিয়ে পাঠানো যাবে না: ফিরে যাওয়ার মতো কোনো ইমেজ এটি জানায়নি।",
            },
            latestRevert: "সর্বশেষ ফিরিয়ে পাঠানো",
            revertStatus: { requested: "অনুরোধ করা হয়েছে", done: "সম্পন্ন", refused: "প্রত্যাখ্যাত", withdrawn: "প্রত্যাহৃত" },
            revertTo: "{version}-এ",
            rolloutsOfBooth: "এর রোলআউট",
            noRolloutsOfBooth: "এটি কোনো রোলআউটে নেই।",
            historyTitle: "ইতিহাস",
            historyHelp: "এটি কী চালিয়েছে আর এর আপডেটগুলোর কী হয়েছে, সবচেয়ে নতুনটি আগে।",
            noHistory: "এখনও কোনো ফার্মওয়্যার ইতিহাস নেই।",
            event: { running: "চলছে", attempt: "আপডেট", revert: "ফিরিয়ে পাঠানো", safe_mode: "নিরাপদ মোড", crash: "ক্র্যাশ" },
            phase: {
                failed: "ব্যর্থ",
                rolled_back: "রোলব্যাক",
                inconclusive: "অনির্ধারিত",
                reverted: "ফিরে গেছে",
                requested: "অনুরোধ করা হয়েছে",
                done: "সম্পন্ন",
                refused: "প্রত্যাখ্যাত",
                withdrawn: "প্রত্যাহৃত",
            },
        },
        nav: {
            primary: "কনসোল বিভাগ",
            dashboard: "ড্যাশবোর্ড",
            shifts: "শিফট",
            variance: "ভ্যারিয়েন্স",
            offlineReviews: "অফলাইন রিভিউ",
            salesReview: "সেলস রিভিউ",
            cardStock: "কার্ড স্টক",
            devices: "ডিভাইস ও হেলথ",
            commands: "কমান্ড",
            maintenance: "মেইনটেন্যান্স",
            calibration: "ক্যালিব্রেশন অনুমোদন",
            firmware: "ফার্মওয়্যার",
            networkDevices: "ডিভাইস ও অনবোর্ডিং",
            wallets: "ওয়ালেট",
            corrections: "কারেকশন",
            cardsCustomers: "কার্ড ও কাস্টমার",
            pricing: "প্রাইসিং ও ট্যাক্স",
            staffAudit: "স্টাফ ও অডিট",
            reports: "রিপোর্ট",
        },
        denied: {
            title: "এই পেজে আপনার অ্যাক্সেস নেই",
            body: "আপনার রোলে এই অংশটি নেই। কাজের জন্য প্রয়োজন হলে একজন অ্যাডমিনকে আপনার অনুমতি যাচাই করতে বলুন।",
            back: "আপনার শুরুর পেজে যান",
        },
        placeholder: {
            title: "{page}",
            body: "এই স্ক্রিনটি পরবর্তী ধাপে আসবে। কনসোল শেল, আপনার রোল-ভিত্তিক নেভিগেশন ও লোকেশন স্কোপ এখন সক্রিয়।",
        },
        operatorEmpty: {
            title: "হ্যালো {name} — এখানে এখনও কিছু নেই",
            titleNoName: "আপনি সাইন ইন করেছেন — এখানে এখনও কিছু নেই",
            body1: "আপনার শিফট টুল — পাঞ্চ ইন, ক্যাশ বিক্রি, কার্ড-প্যাক বিক্রি, শিফট ক্লোজ — সব ডিসপেন্সারেই চলে। এই কনসোল আজ ম্যানেজার, টেকনিশিয়ান ও অ্যাডমিনদের জন্য।",
            body2: "একটি “আমার শিফট” ভিউ (এ পর্যন্ত প্রত্যাশিত ক্যাশ, আপনার কার্ড স্টক) রোডম্যাপে আছে — এর জন্য আগে ব্যাকএন্ডে ছোট একটি সংযোজন দরকার।",
        },
        error: {
            loadFailedTitle: "এই স্ক্রিন লোড করা যায়নি",
            network: "কনসোলে পৌঁছানো যাচ্ছে না — VPN যাচাই করে আবার চেষ্টা করুন।",
            generic: "কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
        },
    },
};
//# sourceMappingURL=bn.js.map